module.exports = __webpack_public_path__ + "media/src/public/images/mail/pretty/peoplecircle-9d645df6c3c13678a10ef53db4ed808e.png";